import { render, staticRenderFns } from "./ExProficiencyWeight.vue?vue&type=template&id=7bce0d8c"
import script from "./ExProficiencyWeight.vue?vue&type=script&lang=js"
export * from "./ExProficiencyWeight.vue?vue&type=script&lang=js"
import style0 from "./ExProficiencyWeight.vue?vue&type=style&index=0&id=7bce0d8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports